import api, { $ } from "kw/api";

import { jsonStringToCamelCase } from "kanopi-components/utils/json";
import { riskProfileFields } from "kw/api/fragments";
import { useGlobal } from "kanopi-components/useGlobal";
import { useGlobalsContext } from "kw/util/Globals";

export function useUpdateExposureEnabled({ exposureId, exposureItemKey }) {
  const globalsContext = useGlobalsContext();
  const [data = {}, setData] = useGlobal(globalsContext);
  const { riskProfile = {} } = data;
  const { id: riskProfileId } = riskProfile;
  async function updateRiskExposure(enabled) {
    const response = await api.mutation(
      {
        updateRiskExposure: [
          {
            input: $("input", "UpdateRiskExposureInput!"),
          },
          {
            ...riskProfileFields,
          },
        ],
      },
      {
        input: {
          riskProfileId,
          exposureId,
          exposureItemKey,
          enabled,
        },
      }
    );
    const riskProfile = response.updateRiskExposure || {};
    setData({
      riskProfile: {
        ...riskProfile,
        riskData: jsonStringToCamelCase(riskProfile.riskData),
      },
    });
  }
  return { setEnabled: updateRiskExposure };
}
